import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import zh from './lang/zh';
import en from './lang/en';
import gu from './lang/gu';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload)
Vue.use(VueI18n);
Vue.config.productionTip = false;
let locale: string | null = 'zh';
if (window.localStorage && window.localStorage.getItem("lang")) locale = window.localStorage.getItem("lang");
const i18n = new VueI18n({ locale: locale ? locale : 'zh', messages: { zh, en, gu } });

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
